import { ModalContext } from "@/app/data/context-api/ModalSystemMessageProvider";

import Cookies from 'js-cookie'
import { jwtDecode } from "jwt-decode";
import { useContext } from "react";
import api from "../api";
import { IAuthority } from "../Authority/interface";

export const authentication = async (username: string, password: string) => {

    const response = api.post('/autenticar', { username: username, password: password, loginWithLdap: process.env.NEXT_PUBLIC_UTILIZA_LDAP });
    return response;

}

export async function authRefresh() {
    const tokenRefresh = getTokenCookies("REFRESH");
    const response = await api.post('/atualizar', tokenRefresh);
    if (response && response.data) {
        setTokenCookies(response.data[0], "PRINCIPAL");
        setTokenCookies(response.data[1], "REFRESH");
    }
    return response
}

export function setTokenCookies(token: string, type: "PRINCIPAL" | "REFRESH") {
    if (type == "PRINCIPAL") {
        if (process.env.NEXT_PUBLIC_TOKEN)
            Cookies.set(process.env.NEXT_PUBLIC_TOKEN, token);
    } else if (type == "REFRESH") {
        if (process.env.NEXT_PUBLIC_TOKEN_REFRESH)
            Cookies.set(process.env.NEXT_PUBLIC_TOKEN_REFRESH, token);

    }
}

export function deleteTokkens() {
    if (process.env.NEXT_PUBLIC_TOKEN)
        Cookies.remove(process.env.NEXT_PUBLIC_TOKEN);

    if (process.env.NEXT_PUBLIC_TOKEN_REFRESH)
        Cookies.remove(process.env.NEXT_PUBLIC_TOKEN_REFRESH);
}

export function getTokenCookies(type: "PRINCIPAL" | "REFRESH") {

    if (type == "PRINCIPAL") {
        if (process.env.NEXT_PUBLIC_TOKEN) {
            return Cookies.get(process.env.NEXT_PUBLIC_TOKEN);
        }
    } else if (type == "REFRESH") {
        if (process.env.NEXT_PUBLIC_TOKEN_REFRESH) {
            return Cookies.get(process.env.NEXT_PUBLIC_TOKEN_REFRESH);
        }
    }
}

export function getTokenExpiredValidation(x: string) {
    if (x.trim() == '')
        return true

    const decoded = jwtDecode(x);
    let ms = Date.now();
    console.log('-----x: ' + decoded.exp)
    console.log('-----y: ' + Math.floor(new Date().getTime() / 1000))
    console.log('-----z: ' + JSON.stringify(decoded))

    if (Math.floor(new Date().getTime() / 1000) > decoded.exp!)
        return true

    return false;
}

export function getIdUserToken() {
    const token = getTokenCookies("PRINCIPAL")
    if (token) {
        const decoded = jwtDecode(token);
        return Number(decoded.id);
    }
    else
        return undefined
}
export function getNameUserToken() {
    const token = getTokenCookies("PRINCIPAL")
    if (token) {
        const decoded = jwtDecode(token);
        return decoded.nome;
    }
    else
        return undefined
}

export function getAuthoritiesToken(): { authority: string[] } | null | undefined {
    const token = getTokenCookies("PRINCIPAL");

    if (token) {
        const decoded: { role?: string | { authority: string }[] } = jwtDecode(token);

        if (Array.isArray(decoded.role)) {
            return {
                authority: decoded.role
                    .filter((auth): auth is { authority: string } => typeof auth === "object" && "authority" in auth)
                    .map(auth => auth.authority),
            };
        } else if (typeof decoded.role === "string") {
            return { authority: [decoded.role] };
        } else {
            return null;
        }
    } else {
        return undefined;
    }
}


export function getSubToken() {
    const token = getTokenCookies("PRINCIPAL")
    if (token) {
        const decoded = jwtDecode(token);
        return decoded.sub;
    }
    else
        return undefined
}

export function expiredTokens() {
    const tokenNormal = getTokenExpiredValidation(getTokenCookies("PRINCIPAL") ?? '')
    const tokenRefresh = getTokenExpiredValidation(getTokenCookies("REFRESH") ?? '');

    if (tokenNormal == true && tokenRefresh == true) {
        return true
    }

    return false;
}


export function verifyIndividualAuthority(auth: string) {
    /* retorno = 1 - tem permissão, 0 - não tem permissão */
    let retorno = 0;

    // Pegamos o retorno da função getAuthoritiesToken
    const autoridade = getAuthoritiesToken();

    // Garantimos que a variável autoridade existe e que authority é um array
    if (autoridade && Array.isArray(autoridade.authority)) {
        // Verificamos se auth está presente na lista de authorities
        if (autoridade.authority.includes(auth)) {
            retorno = 1; // Permissão encontrada
        }
    }

    
    return retorno; // Retorna 0 ou 1
}
